import React, { Component } from 'react';
import { connect } from 'react-redux';

import HeadingBox from '../../UI/Headings/HeadingBox/HeadingBox';
import HeadingH2 from '../../UI/Headings/HeadingH2/HeadingH2';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';
import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import Button from '../../UI/Button/Button';
import TextLink from '../../UI/TextLink/TextLink';
import TooltipError from '../../UI/TooltipError/TooltipError';
import TextSpinner from '../../UI/TextSpinner/TextSpinner';

import * as authActions from '../../../store/actions/index';

class AuthLogin extends Component {

    state = {
        userPassword: ''
    }

    inputChangeHandler = (event) => {
        this.setState({
            userPassword: event.target.value
        });
    }

    keyPressHandler = (event) => {
        if(event.key === 'Enter') {
            this.props.onNormalLogin(this.props.email, this.state.userPassword)
        }
    }

  render() {
    const border = '1px solid var(--color-border)';
    return (
        <React.Fragment>
            <div className={`mb-10 u-phoneTextAlignCenter`}>
                <HeadingBox>
                    <div className="mb-1">
                        <HeadingH2 size={26} weight="Regular" color="Dark">Welcome to Traverse!</HeadingH2>
                    </div>
                    <HeadingH3 size={13} weight="Regular" color="Light">Enter your Password to Sign In</HeadingH3>
                </HeadingBox>
            </div>
            <div className={`u-flex align-items-center u-height60 u-relative`}>
                <InputMaterial 
                    type='email' 
                    label='Email' 
                    value={this.props.email} 
                    alignment='left' 
                    disabled
                    />
            </div>
            <div className={`u-flex align-items-center u-height60 u-relative`}>
                <TooltipError showTooltip={this.props.loginError} type="loginError" aria-label="Incorrect Password" />
                <InputMaterial 
                    type='password' 
                    label='Password' 
                    value={this.state.userPassword} 
                    alignment='left' 
                    onChange={this.inputChangeHandler}
                    onKeyPress={this.keyPressHandler}
                    style={{borderBottom: this.props.loginError ? '2px solid #FC1D00' : `${border}`}}
                    />
            </div>
            <div className={`u-flex justify-content-between align-items-center mt-6 mb-6`}>
                <TextLink type='fill' onClick={() => this.props.onSetAuthView('forgotPassword')}>Forgot Password ?</TextLink>
            </div>
            <div className={`mb-10 u-flex justify-content-center align-items-center`}>
                <Button theme='Primary' type='Login' width='Block' onClick={() => this.props.onNormalLogin(this.props.email, this.state.userPassword)}>{this.props.loggingIn || this.props.otpLoading ? <TextSpinner type='White'/> : 'Sign in'}</Button>
            </div>
        </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
    return {
        authType: state.auth.authType,
        email: state.auth.email,
        loginError: state.auth.loginError,
        loggingIn: state.auth.loggingIn,
        otpLoading: state.auth.otpLoading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onNormalLogin: (email, password) => dispatch(authActions.normalLogin(email, password)),
        onSetAuthView: (view) => dispatch(authActions.setAuthView(view))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthLogin);



// WEBPACK FOOTER //
// ./src/components/Authentication/AuthLogin/AuthLogin.js